export default "__VITE_ASSET__CgaYtKmN__"